import { render, staticRenderFns } from "./NewChange.vue?vue&type=template&id=4a771a36&"
import script from "./NewChange.vue?vue&type=script&lang=ts&"
export * from "./NewChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports